import { BasePageProps } from '../BasePage'
import { PageWithBuildingState, buildingInitialState } from '../PageWithBuilding'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface FirePageProps extends BasePageProps {}

type FireState = {
    polizza_mutuo: boolean | undefined
    durata_mutuo: number | undefined
    data_surroga: string | undefined

    polizza_mutuoError: string | undefined
    durata_mutuoError: string | undefined
    data_surrogaError: string | undefined
}

export type FirePageState = FireState & PageWithBuildingState

export const firePageInitialState : FirePageState = {
    ...buildingInitialState,
    ...{
        polizza_mutuo: undefined,
        durata_mutuo: undefined,
        data_surroga: undefined,

        polizza_mutuoError: undefined,
        durata_mutuoError: undefined,
        data_surrogaError: undefined,
        
        altriSinistri: false   // VALORE defaultato --> https://app.clickup.com/t/86bwjrc80
    }
}

export const fireUpdate = createAction<FirePageState>('fire/update')

export const fireReducer = createReducer ( 
    firePageInitialState,
    (builder) => {
        builder.addCase(fireUpdate, (state, action) => {
            return action.payload as FirePageState
        })
    }
)

export type FireRootState = ReturnType<typeof store.getState>
export type FireDispatch = typeof store.dispatch